// Kontots skal: menyn, användaren och sidan (designen Admin-*).
import { plans } from '@leadledger/domain';
import { Link, NavLink, Outlet } from 'react-router';
import { useBetalning } from '../api/queries.js';
import { useAuth, useMe } from '../auth/auth.js';
import { ikoner, Marke } from './ikoner.js';
import { MENY } from './meny.js';

/** Dit knappen i bannern leder när kortbetalningen inte är öppen: LeadLedgers kontaktadress. */
export const KONTAKT_URL =
  'mailto:info@leadledger.se?subject=' + encodeURIComponent('Bli fullständig byråkund');

/** "Solo 999 kr och Byrå 1 999 kr i månaden" ur planerna. */
const kronor = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 });
const PRISER = plans
  .map((p) => `${p.name} ${kronor.format(p.monthlyPrice / 100)} kr`)
  .join(' och ');

/**
 * Bannern för en byrå i förhandsvisning (ADR 0106). Den syns på alla sidor
 * tills byrån har betalat, och leder till planvalet och betalningen
 * (ADR 0117). Är kortbetalningen inte öppen leder den till info@.
 */
function Forhandsvisning() {
  const betalning = useBetalning();
  const kanBetala = betalning.data?.paymentsEnabled === true;
  return (
    <section className="forhandsvisning" aria-label="Förhandsvisning">
      <div>
        <strong>Kom igång – välj plan och betala med kort</strong>
        <p>
          Kontot är en förhandsvisning med påhittade exempel. Ni kan titta runt, men inte ändra
          något, och formuläret tar inte emot förfrågningar förrän ni har valt plan.{' '}
          {kanBetala
            ? `${PRISER} i månaden, exklusive moms. Ingen bindningstid.`
            : 'Kontakta oss, så kommer ni igång.'}
        </p>
      </div>
      {kanBetala ? (
        <Link className="btn btn-p" to="/valj-plan">
          Välj plan och betala
        </Link>
      ) : (
        <a className="btn btn-p" href={KONTAKT_URL}>
          Kom igång nu
        </a>
      )}
    </section>
  );
}

/** KE för Karin Ek, J för Johan. */
export function initialer(namn: string): string {
  return namn
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((del) => del[0]?.toUpperCase() ?? '')
    .join('');
}

export function Shell() {
  const me = useMe();
  const { loggaUt } = useAuth();
  return (
    <div className="skal">
      <a className="hoppa" href="#innehall">
        Hoppa till innehållet
      </a>
      <aside className="meny">
        <Link className="marke" to="/">
          <Marke />
          LeadLedger
        </Link>
        <nav aria-label="Huvudmeny">
          <ul>
            {MENY.map((val) => (
              <li key={val.till}>
                <NavLink className="ni" to={val.till} end={val.till === '/'}>
                  {ikoner[val.ikon]}
                  {val.etikett}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="anvandare">
          <div className="initialer" aria-hidden="true">
            {initialer(me.user.name)}
          </div>
          <div>
            <div className="namn">{me.user.name}</div>
            <div className="byra">{me.tenant.name}</div>
          </div>
          <button type="button" className="logga-ut" onClick={loggaUt}>
            Logga ut
          </button>
        </div>
        {/* Hjälpen (ADR 0105) och avtalen som byrån har godkänt (ADR 0100). */}
        <nav className="meny-fot" aria-label="Hjälp och avtal">
          <Link to="/resurser">Resurser</Link>
          <Link to="/villkor">Allmänna villkor</Link>
          <Link to="/bitradesavtal">Biträdesavtal</Link>
        </nav>
      </aside>
      <div className="skal-innehall">
        {me.tenant.access === 'preview' && <Forhandsvisning />}
        <Outlet />
      </div>
    </div>
  );
}
